import React, { useState } from "react";
import { connect } from "react-redux";
import Navbar from "./Navbar";
import { ContactApi } from "../../api/idx";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "./Footer";
import { successMessage } from "./Util/Toaster";
import { NewFooter } from "./Pages/NewFooter";
import NewContactUs from "./Pages/NewContactUs";
import { NewNavbar } from "./Pages/NewNavbar";

export interface Contactus {
  first_name: string | null;
  last_name: string | null;
  phone: string | null;
  email: string | null;
  message: string | null;
}

const ContactUs = () => {
  const notify = () => toast("Your  Contact successfully!");

  const [contact, setContact] = useState<Contactus>({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [validation, setValidation] = useState<Contactus>({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    message: "",
  });

  const checkValidation = () => {
    let errors = JSON.parse(JSON.stringify(validation));

    if (contact.first_name === null) {
      errors.first_name = "First Name is required";
    } else {
      switch (true) {
        case !contact.first_name.trim():
          errors.first_name = "First Name is required";
          break;
        case !/^[a-zA-Z]+$/.test(contact.first_name):
          errors.first_name = "First Name can only contain letters";
          break;
        case contact.first_name.length < 2:
          errors.first_name = "First Name must be at least 2 characters";
          break;
        case contact.first_name.length > 25:
          errors.first_name = "First Name cannot exceed 25 characters";
          break;
        default:
          errors.first_name = "";
      }
    }

    // Last Name validation
    if (contact.last_name === null) {
      errors.last_name = "Last Name is required";
    } else {
      switch (true) {
        case !contact.last_name.trim():
          errors.last_name = "Last Name is required";
          break;
        case !/^[a-zA-Z]+$/.test(contact.last_name):
          errors.last_name = "Last Name can only contain letters";
          break;
        case contact.last_name.length < 2:
          errors.last_name = "Last Name must be at least 2 characters";
          break;
        case contact.last_name.length > 25:
          errors.last_name = "Last Name cannot exceed 25 characters";
          break;
        default:
          errors.last_name = "";
      }
    }

    // Email validation
    if (contact.email === null) {
      errors.email = "Email is required";
    } else {
      const emailCond = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      switch (true) {
        case !contact.email.trim():
          errors.email = "Email is required";
          break;
        case !emailCond.test(contact.email):
          errors.email = "Please enter a valid email address";
          break;
        default:
          errors.email = "";
      }
    }
    // phone number validation

    if (contact.phone === null) {
      errors.email = "Phone number is required";
    } else {
      switch (true) {
        case !contact.phone.trim():
          errors.phone = "Contact Number is required";
          break;
        case !/^\d+$/.test(contact.phone):
          errors.phone = "Contact number can only contain numbers";
          break;
        case contact.phone.length !== 10:
          errors.phone = "Contact number must be 10 digits";
          break;
        default:
          errors.phone = "";
      }
    }

    return errors;
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setContact({ ...contact, [name]: value });
  };

  const handleSubmit = async () => {
    let validations = await checkValidation();
    if (Object.values(validations).every((value) => value === "")) {
      let res = await ContactApi(contact);
      notify();
      switch (res) {
        case "Your  Contact successfully":
          successMessage("Your request has been submitted succesfully");
          notify();
          setValidation(() => ({
            first_name: "",
            last_name: "",
            phone: "",
            email: "",
            message: "",
          }));
          setContact({
            first_name: "",
            last_name: "",
            phone: "",
            email: "",
            message: "",
          });
          break;
      }
    } else {
      setValidation((prevState) => ({
        ...prevState,
        first_name: validations.first_name,
        last_name: validations.last_name,
        email: validations.email,
        phone: validations.phone,
        message: validations.message,
      }));
    }
  };

  return (
    <div>
      <NewNavbar />

      <div className="login-bg signup-bg pt-5">
        <NewContactUs />
      </div>

      <ToastContainer
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Footer activeSection="" />
    </div>
  );
};

export default connect(() => ({}))(ContactUs);

export const Validation = ({ state }: { state: any }) => {
  return state && <p style={{ color: "red" }}>{state}</p>;
};
